import React, { CSSProperties, useEffect, useMemo } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { covertErrors, ResponseError } from "utils/ErrorConverter";
// import { FormStatusContext } from "../Form/Form";
import { Popup } from "../Popup/Popup";
import { FormStatusContext } from "../Form/Form";

type PopupProps = {
  children?: React.ReactNode;
  show?: boolean;
  label: string;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  onClose: () => void;
  zIndex?: number;
  fullHeight?: boolean;
  fullScreen?: boolean;
  onSubmit?: (data: any) => void;
  error?: { message: string; errors: ResponseError };
  isLoading?: boolean;
  defaultValues?: any;
  formStyle?: CSSProperties;
  TransitionComponent?: React.JSXElementConstructor<any>;
};

export const PopupForm: (props: PopupProps) => JSX.Element = (props) => {
  const methods = useForm({ defaultValues: props.defaultValues });

  const errors = useMemo(() => {
    if (!props.error) {
      return [];
    }

    return covertErrors({
      errors: props?.error?.errors,
    });
  }, [props.error]);

  useEffect(() => {
    for (const error of errors) {
      methods.setError(error.key, { message: error.message });
    }
  }, [errors, methods]);

  useEffect(() => {
    methods.reset(props.defaultValues);
  }, [methods, props.defaultValues]);

  const contextValue = useMemo(
    () => ({ isLoading: props.isLoading || false }),
    [props.isLoading]
  );

  return (
    <FormStatusContext.Provider value={contextValue}>
      <FormProvider {...methods}>
        <Popup
          show={props.show}
          label={props.label}
          maxWidth={props.maxWidth}
          onClose={props.onClose}
          zIndex={props.zIndex}
          fullHeight={props.fullHeight}
          fullScreen={props.fullScreen}
          PaperProps={{
            component: "form",
            onSubmit: props.onSubmit
              ? methods.handleSubmit(props.onSubmit)
              : undefined,
            sx: props.formStyle,
          }}
          TransitionComponent={props.TransitionComponent}
        >
          {props.children}
        </Popup>
      </FormProvider>
    </FormStatusContext.Provider>
  );
};
